import { ShellLayout } from "@/components/shell/ShellLayout";
import { ChangePasswordForm } from "@/components/security/ChangePasswordForm";
import { SessionsPanel } from "@/components/security/SessionsPanel";
import { EmailVerificationCard, MfaStatusCard } from "@/components/security/StatusCards";

export default function HubSecurity() {
  return (
    <ShellLayout area="hub" eyebrow="Staff hub" title="Security">
      <div data-testid="hub-security-page" className="space-y-6">
        <div className="grid gap-6 lg:grid-cols-2">
          <MfaStatusCard />
          <EmailVerificationCard />
        </div>
        <ChangePasswordForm />
        <SessionsPanel />
      </div>
    </ShellLayout>
  );
}
